import { TrainingBillingStatus } from '../types/trainingBilling'

export const VAT_RATE = 0.22

export const trainingBillingStatuses: TrainingBillingStatus[] = [
  'Proforma da fare',
  'Proforma effettuata',
  'Fattura da fare',
  'Fattura effettuata',
  'Pagamento in revisione',
  'Fattura pagata',
  'Fattura non pagata',
  'Sollecito 1',
  'Sollecito 2',
  'Sollecito 3',
  'Comunicazione recupero crediti',
  'Procedura recupero crediti',
]

// Statuses set automatically from the practice
export const statusesFromPractice: TrainingBillingStatus[] = [
  'Proforma da fare',
  'Fattura da fare',
]
